// Toolkit Imports
import { C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";
import { useCertificateActions } from "sj-ui-toolkit/src/hooks";

// 3rd Party Imports
import { useNavigate } from "react-router";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { PassedBelt } from "sj-ui-toolkit/src/api";

// Local Imports
import S from "./PathCompletionPage.module.scss";

export function PathCompletionPage({ completedPath }: { completedPath: PassedBelt }) {
  const {
    emailUrl,
    levelName,
    linkedinUrl,
    name,
    twitterUrl,
    lessonsCompleteCount,
    roleEnrollmentPublicId,
    roleId,
  } = completedPath || {};

  const navigate = useNavigate();

  const {
    handleCertificateDownload,
    viewCertificate,
    sendCertificateEmail,
    onOpenLink,
    isDownloading,
  } = useCertificateActions();

  const items = [
    {
      label: "View Your Certificate",
      icon: "pi pi-eye",
      command: () => viewCertificate({ roleEnrollmentPublicId }),
    },
    {
      label: "Send a copy via Email",
      icon: "pi pi-envelope",
      command: () => sendCertificateEmail({ emailUrl }),
    },
    {
      label: "Share on LinkedIn",
      icon: "pi pi-linkedin",
      command: onOpenLink(linkedinUrl),
    },
    {
      label: "Share on X",
      icon: "pi pi-twitter",
      command: onOpenLink(twitterUrl),
    },
  ];

  return (
    <div className={C("atlas-bg-home", S.root)}>
      <div className={S.content}>
        <header className={S.completionHeader}>
          <h2 className="atlas-h2 mb-4">Secure Coding Mode: Activated!</h2>
          <p className="atlas-h5">You&apos;ve completed your path and earned a certificate!</p>
        </header>

        <section>
          <div className={S.pathDetail}>
            <strong className="text-muted">Path Name</strong>
            <p className="atlas-h4">
              {levelName} | {name}
            </p>
          </div>

          <div className={S.pathDetail}>
            <strong className="text-muted">Lessons Completed</strong>
            <p className="atlas-h4">{lessonsCompleteCount}</p>
          </div>
        </section>

        <div className={S.actions}>
          <Button
            label="Back to Dashboard"
            icon="pi pi-home"
            iconPos="left"
            onClick={() => navigate("/")}
            severity="secondary"
          />
          <SplitButton
            onClick={() => handleCertificateDownload(roleId)}
            label="Download Your Certificate"
            model={items}
            disabled={isDownloading}
            loading={isDownloading}
            icon="pi pi-download"
            menuStyle={{ minWidth: "max-content" }}
          />
        </div>
      </div>
    </div>
  );
}
